<div class="container-fluid page">
  <div class="d-flex page__box p-3 mt-2">
    <img
      src="./assets/arrow_logo.png"
      class="arrow"
      (click)="listPage()"
    />&nbsp;Add a New Blog Post
  </div>
  <div class="profile_details">
    <div class="page__content shadow p-3">
      <div class="row" style="justify-content: space-between !important">
        <div class="col-md-8">
          <form [formGroup]="form">
            <div class="example-header" style="padding: 10px 0 0">
              <span>
                <mat-form-field style="width: 31%">
                  <mat-select
                    placeholder="Category"
                    formControlName="categorydata"
                  >
                    <mat-option
                      *ngFor="let blog of maincategory"
                      [value]="blog.categoryID"
                    >
                      <!-- <img with="20" height="20" [src]="blog.imageURL" /> -->
                      {{ blog.categoryName }}
                    </mat-option>
                  </mat-select> </mat-form-field
                >&nbsp;

                <button type="button"
                  class="add_button_new"
                  mat-raised-button
                  color="primary"
                  (click)="manageCategory()"
                >
                  Manage Category</button
                >&nbsp;
              </span>

              <!-- <mat-form-field style="width: 31%">
                <mat-label>Category</mat-label>
                <mat-select placeholder="Category">
                  <mat-option
                    *ngFor="let opt of maincategory"
                    [value]="opt.categoryID"
                  >
                    <img with="20" height="20" [src]="opt.imageURL" />
                    {{ opt.categoryName }}
                  </mat-option>
                </mat-select> -->
              <!-- <mat-select
                  [(ngModel)]="roledata"
                  formControlName="type"
                  (selectionChange)="doSomething($event)"
                >
                  <mat-option
                    *ngFor="let food of rolebased"
                    [value]="food.role"
                  >
                    {{ food.role }}
                  </mat-option>
                 </mat-select>  </mat-form-field
              >&nbsp; -->

              <mat-form-field style="width: 31%">
                <mat-label>Languages</mat-label>
                <mat-select
                  [(ngModel)]="Language"
                  formControlName="Language"
                  required
                >
                  <mat-option
                    *ngFor="let language of languageList"
                    [value]="language.value"
                  >
                    {{ language.viewValue }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field class="full-width-field">
                <input
                  matInput
                  (keypress)="keyPressAlphaNumeric($event)"
                  [(ngModel)]="title"
                  formControlName="titledata"
                  placeholder="Blog title"
                />
              </mat-form-field>
              <div class="row">
                <div class="col-sm-9">
                  <span>
                    <div class="file-upload-header">Thumbnail image</div>
                    <input
                      type="file"
                      name="image"
                      class="file-input"
                      (change)="newsFileSelected($event)"
                      #fileUpload
                    />
                    <button class="file-upload" (click)="fileUpload.click()">
                      <mat-icon>cloud_upload</mat-icon>
                    </button>
                  </span>
                  <div
                    *ngIf="f['image'].touched && f['image'].invalid"
                    style="font-size: 1rem"
                  >
                    <mat-error
                      *ngIf="f['image'].errors && f['image'].errors['required']"
                      >Image is required.</mat-error
                    >
                    <!-- <div *ngIf="f['name'].errors && f['name'].errors['minlength']">Name should be 3 character.</div> -->
                  </div>
                  &nbsp;&nbsp;
                </div>
                <div class="col-sm-3">
                  <img
                    [src]="imageSrc"
                    class="imagePreview"
                    alt=""
                    accept="image/*"
                  />
                </div>
              </div>
            </div>

            <!-- <ckeditor [editor]="editor" [(ngModel)]="name"></ckeditor> -->
            <!-- </form> -->
            <div style="margin-top: 5px" class="editor">
              <ckeditor
                id="ckeditorId"
                class="ck-editor__editable"
                [(ngModel)]="name"
                formControlName="ckeditordata"
                name="myckeditor"
                required
                [config]="ckeConfig"
                debounce="500"
                (ngModelChange)="onChange($event)"
              >
              </ckeditor>
              <!-- <ckeditor name="myckeditor" [(ngModel)]="name" formControlName="ckeditordata" debounce="300" [editor]="editor"></ckeditor> -->
            </div>

            <mat-form-field style="width: 100%">
              <input
                matInput
                [(ngModel)]="remark"
                formControlName="remark"
                autocomplete="off"
                placeholder="Remarks"
              /> </mat-form-field
            ><br />
          </form>
        </div>

        <div class="col-md-4">
          <div class="d-flex row page__box_image p-2 mt-2" style="color: white">
            <div class="col-md-8 col-sm-8">
              <span>Image Gallery</span>
            </div>

            <div class="col-md-4 col-sm-4 pull-right;">
              <div style="float: right">
                <button
                  type="file"
                  onclick="document.getElementById('getFile').click()"
                  class="add_image"
                >
                  <mat-icon style="font-size: 30px">control_point</mat-icon>
                </button>
                <input
                  type="file"
                  id="getFile"
                  multiple
                  (change)="processImage($event)"
                  #inputFile
                  style="display: none"
                />&nbsp;
                <mat-icon class="delete_image" (click)="deleteImage()"
                  >delete</mat-icon
                >
              </div>
            </div>
          </div>

          <div
            class="d-flex row page__box_image p-2"
            style="
              margin-bottom: 10px;
              color: black;
              background: #efefadc2;
              margin-top: 15px;
            "
          >
            <div class="col-md-1 col-sm-1" style="padding: 0">
              <img src="/assets/info.png" style="height: 35px" />
            </div>
            <div class="col-md-11 col-sm-11" style="padding: 0">
              <span class="info_para"
                >Drag and drop Images to insert in blog.</span
              >
            </div>
          </div>

          <div style="background-color: #f4f4f4; height: 82vh">
            <div
              class="container"
              Style="max-height: 82vh; overflow-y: auto; width:100%; padding: 0px 12px 0px 0px;"
            >
              <div
                class="row justify-content-around align-items-center"
                Style="overflow-y:auto; overflow-x: hidden;"
              >
                <div class="row">
                  <!-- <div class="col-lg-3 col-md-6 col-sm-12  m-3" *ngFor="let item of newImageurllisting"> -->
                  <div
                    class="col-lg-4 col-md-4 col-sm-12"
                    *ngFor="let item of newImageurllisting"
                  >
                    <div style="position: relative">
                      <img
                        src="{{ item.imageUrl }}"
                        alt=""
                        class="gallery_images"
                      />
                      <mat-checkbox
                        style="position: absolute; top: -16px; right: -12px"
                        name="list_name"
                        [(ngModel)]="item.isSelected"
                      ></mat-checkbox>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--This is image gallery-->
          </div>
        </div>

        <div
          class="row d-flex row"
          style="float: right; margin-top: -20px; padding: 0px"
        >
          <div class="col-md-9 col-sm-9 col-lg-9"></div>
          <div
            class="col-md-3 col-sm-3 col-lg-3 pull-right"
            style="display: inline-flex; margin-top: 10px; padding: 0px"
          >
            <button
              type="submit"
              mat-raised-button
              class="submit_button"
              color="primary"
              (click)="resetButton()"
            >
              Reset</button
            >&nbsp;
            <button
              type="submit"
              class="submit_button"
              mat-raised-button
              color="primary"
              (click)="onSubmit()"
            >
              Publish
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
